import { useQuery } from "@apollo/client";
import type {
  AdminDashboardQueryType,
  AdminDashboardQueryVariablesType,
  AdminDashboardTodayQueryType,
  AdminUnpaidInvoicesQueryType,
} from "@/types/graphql/admin.generated";
import {
  AdminDashboardQuery,
  AdminDashboardTodayQuery,
  AdminUnpaidInvoicesQuery,
} from "../graphql/queries";

/**
 * Дашборд за период. При смене периода data пустеет до прихода ответа,
 * старый период потребитель показывает из previousData.
 */
export function useAdminDashboardQuery(
  variables: AdminDashboardQueryVariablesType
) {
  return useQuery<AdminDashboardQueryType, AdminDashboardQueryVariablesType>(
    AdminDashboardQuery,
    { variables, notifyOnNetworkStatusChange: true }
  );
}

/** Значения на сегодня не зависят от периода и не перезапрашиваются при его смене. */
export function useAdminDashboardTodayQuery() {
  return useQuery<AdminDashboardTodayQueryType>(AdminDashboardTodayQuery, {
    notifyOnNetworkStatusChange: true,
  });
}

/** Неоплаченные счета не зависят от периода. */
export function useAdminUnpaidInvoicesQuery() {
  return useQuery<AdminUnpaidInvoicesQueryType>(AdminUnpaidInvoicesQuery, {
    notifyOnNetworkStatusChange: true,
  });
}
